// extracted by mini-css-extract-plugin
module.exports = {"table":"Checks-module__table___1i-k5","metrics":"Checks-module__metrics___3STNX","filters":"Checks-module__filters___2RSID","empty":"Checks-module__empty___2rE5o"};